import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Models
import IState, { SLICE_NAME } from "./pagesToolbar.models";
// Storage
import {
  getNewDesignEnabled, onUpdateNewDesignEnabled,
  getFiltersSidebarOpen, onUpdateFiltersSidebarOpen
} from "./pagesToolbar.storage";

const initialState:IState = {
  newDesignEnabled: getNewDesignEnabled(),
  filtersSidebarOpen: getFiltersSidebarOpen(),
  selectedPageIds: [],
  loadingPageIds: []
};

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    // Change new design
    toggleNewDesignEnabled: (state) => {
      const enabled = !state.newDesignEnabled;
      state.newDesignEnabled = enabled;
      onUpdateNewDesignEnabled(enabled);
    },
    // Change filters sidebar
    toggleFiltersSidebarOpen: (state) => {
      const open = !state.filtersSidebarOpen;
      state.filtersSidebarOpen = open;
      onUpdateFiltersSidebarOpen(open);
    },
    // Change selected pages
    setSelectedPages: (state, action: PayloadAction<string[]>) => {
      state.selectedPageIds = action.payload;
    },
    addSelectedPage: (state, action: PayloadAction<{ documentId:number; pageNum:number }>) => {
      const { documentId, pageNum } = action.payload;
      const pageId = `${documentId}:${pageNum}`;
      if ( !state.selectedPageIds.includes(pageId) ) {
        state.selectedPageIds = [...state.selectedPageIds, pageId];
      }
    },
    removeSelectedPage: (state, action: PayloadAction<{ documentId:number; pageNum:number }>) => {
      const { documentId, pageNum } = action.payload;
      const pageId = `${documentId}:${pageNum}`;
      state.selectedPageIds = state.selectedPageIds.filter(id => id !== pageId);
    },
    clearSelectedPages: (state) => {
      state.selectedPageIds = [];
    },
    // Change loading pages
    setLoadingPages: (state, action: PayloadAction<string[]>) => {
      state.loadingPageIds = action.payload;
    },
    removeLoadingPage: (state, action: PayloadAction<{ documentId:number; pageNum:number }>) => {
      const { documentId, pageNum } = action.payload;
      const pageId = `${documentId}:${pageNum}`;
      state.loadingPageIds = state.loadingPageIds.filter(id => id !== pageId);
    }
  }
});

export const PagesToolbarActions = slice.actions;

export default slice;
